export const dispatchChangeEvent = (input: HTMLInputElement, value: string | number): void => {
  if (input.value === `${value}`) return;

  /**
   * This is a hack to get React 16.8 to trigger the input's `onChange` handler.
   */
  delete (input as any)["value"];
  input.value = `${value}`;

  /**
   * Set a new value on the value track to force React to trigger the `onChange` handler.
   */
  (input as any)._valueTracker?.setValue?.(`${value}_`);

  const event = new InputEvent("input", { bubbles: true, data: `${value}` });
  input.dispatchEvent(event);
};
